import UllimApp from './ullim-education-app';
function App() { return <UllimApp />; }
export default App;
